/* global window */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../../../../components/ErrorBoundary/ErrorBoundary';
import { TRACKING_EVENTS } from '../../../../BookAppointmentV2/constants';
function ErrorScreen({ track }) {
    useEffect(() => {
        if (track) {
            track(TRACKING_EVENTS.BOOK_APPOINTMENT_ERROR_SHOWN, {
                error_message: 'Oops! Something went wrong, please try again later'
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleRetry() {
        if (track) {
            track(TRACKING_EVENTS.BOOK_APPOINTMENT_TAP_RETRY);
        }
        window.location.reload();
    }

    return (
        <ErrorBoundary
            handleErrorClick={ handleRetry }
        />
    );
}

ErrorScreen.propTypes = {
    track: PropTypes.func

};

export default ErrorScreen;
